import React from 'react'
import AcquireWebComponent from '../../framework/MaterialUI'
import { Row, Col, FullRow } from '../../framework/Grid/'

class HashedEmailVariables extends AcquireWebComponent {
	render(){
		const {hashCase, hashFormat} = this.props
		return (
			<FullRow className="black-border p-10 no-margin-left no-margin-right mb-20">
				<Row className="pl-10 pt-10 no-padding-top no-padding-bottom">
					<Col xs="4" md="4" sm="4" lg="4" className="no-padding-left">
						<strong>Variable Type</strong>
					</Col>
					<Col xs="4" md="4" sm="4" lg="4" className="no-padding-left">
						<div className="input-group" >
							<span>Hashed Email</span>
						</div>
					</Col>
				</Row>
				<Row className="no-padding-top no-padding-bottom pl-10">
					<Col xs="8" sm="8" md="8" lg="8" style={{background:"#F6F6F6"}}>
						<Row className="black-border no-padding-left no-padding-right pt-10 no-margin-bottom">
						<Col xs="5" sm="5" md="5" lg="5">
							<strong>Hash Format</strong>
							<div className="mt-5">
								<input type="checkbox" name="hast_format_md5" 
																	value={"MD5"} 
																	checked={hashFormat.indexOf("MD5") >= 0} 
																	onChange={this.props.handleHashFormatChanged}
																	/>&nbsp;&nbsp;MD5<br />
							</div>
							<div className="mt-5">
								<input type="checkbox" name="hast_format_md5" 
																	value={"SHA1"} 
																	checked={hashFormat.indexOf("SHA1") >= 0} 
																	onChange={this.props.handleHashFormatChanged}
																	/>&nbsp;&nbsp;SHA1<br />
							</div>
							<div className="mt-5">
								<input type="checkbox" name="hast_format_md5" 
																	value={"SHA256"} 
																	checked={hashFormat.indexOf("SHA256") >= 0} 
																	onChange={this.props.handleHashFormatChanged}
																	/>&nbsp;&nbsp;SHA256<br />
							</div>
						</Col>
						<Col xs="6" sm="6" md="6" lg="6" style={{color : hashFormat.length > 0 ? "#000" : "#9C9C9C"}}>
							<strong>Hash Case</strong><br />
							<div className="mt-5">
								<input type="radio" name="hash_case_upper" disabled={hashFormat.length <= 0}
																	value={"upper"} 
																	checked={hashCase === "upper"} 
																	onChange={this.props.handleHashCaseChanged}
																	/>&nbsp;&nbsp;All Upper-case<br />
							</div>
							<div className="mt-5">
								<input type="radio" name="hash_case_lower" disabled={hashFormat.length <= 0}
																	value={"lower"} 
																	checked={hashCase === "lower"} 
																	onChange={this.props.handleHashCaseChanged}
																	/>&nbsp;&nbsp;All Lower-case<br />
							</div>
						</Col>
						</Row>
					</Col>
				</Row>
			</FullRow>
		)

	}
}

export default HashedEmailVariables


// WEBPACK FOOTER //
// ./src/components/Insights/tags/HashedEmail.jsx